import classnames from 'classnames';
import React, { useRef, useState } from 'react';
import Draggable from 'react-draggable';
import { Bar, Bars, Inner, Line, Wrapper } from './NavBarSwitcher.style';

export type NavBarSwitcherProps = {
  children: React.ReactNode[];
  currentBarIndex: number;
  navbarWidth: number;
  onResize: (width: number) => void;
};

export function NavBarSwitcher(props: NavBarSwitcherProps) {
  const { currentBarIndex, navbarWidth = 300 } = props;
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const nodeRef = useRef<HTMLDivElement>(null);

  const className = classnames('bar', `index-${currentBarIndex}`, {});

  const styleBar = {
    maxWidth: `${navbarWidth}px`,
    minWidth: `${navbarWidth}px`,
    // transform: `translateX(-${currentBarIndex * navbarWidth}px)`,
  };

  const style = {
    maxWidth: `${navbarWidth}px`,
    minWidth: `${navbarWidth}px`,
  };

  function onStop(ev: any) {
    props.onResize(ev.clientX);
  }

  return (
    <Wrapper style={style} className='NavBarSwitcher-wrapper' data-testid='NavBarSwitcher-wrapper'>
      <Inner style={style}>
        <Bars style={styleBar} className={className}>
          <Bar style={style}>{props.children[0]}</Bar>
          <Bar style={style}>{props.children[1]}</Bar>
        </Bars>
      </Inner>
      <Draggable position={position} onStop={onStop} nodeRef={nodeRef}>
        <Line ref={nodeRef} />
      </Draggable>
    </Wrapper>
  );
}

export default NavBarSwitcher;
